import Swiper, { Autoplay, Pagination, Navigation } from 'swiper';
import lightGallery from 'lightgallery';

export function LightboxGallery() {
  const galleries = document.querySelectorAll('.wp-block-gallery');

  galleries.forEach((gallery) => {
    const images = gallery.querySelectorAll('.wp-block-image');
    let isLightbox = false;

    images.forEach((image) => {
      if(image.querySelector('a')) {
        isLightbox = true;

        const caption = image.querySelector('.wp-element-caption');
        if(caption) {
          image.querySelector('a').setAttribute('data-sub-html', caption.innerHTML);
        }
      }
    });

    if(isLightbox) {
      gallery.classList.add('is-lightgallery');
      lightGallery(gallery, {
        licenseKey: '4B0B052C-5BCB4CCF-99EF0E30-D0B78394',
        selector: '.wp-block-image a',
        download: false,
      });
    }
  });
}

export function MasonryGrid() {
    document.querySelectorAll('.is-style-masonry-grid').forEach(gallery => {
        gallery.classList.forEach(className => {
            if( className !== 'wp-block-gallery' && className !== 'is-style-masonry-grid' ){
                gallery.classList.remove(className);
            }
        });
    });

}

export const prepareGallery = (gallery) => {
  //  console.log(gallery);
    const imageBlocks = gallery.querySelectorAll(".wp-block-image");

    if (imageBlocks.length > 1) {
        let parent = gallery.parentNode;
      //  console.log(parent);
        let mainwrapper = document.createElement('div');
        let wrapper = document.createElement('div');
        let slides = gallery.querySelectorAll('.wp-block-image');

        wrapper.classList.add(['swiper-wrapper']);
        mainwrapper.classList.add(['swiper']);
        if( gallery.classList.contains('is-style-full-width-slider') ){
            gallery.classList.add(['alignfull']);
        }
        gallery.classList.remove(['is-layout-flex']);

        slides.forEach(slide => {
            slide.classList.add('swiper-slide');
            wrapper.appendChild(slide);
        });

      //  parent.replaceChild(mainwrapper, gallery);
        mainwrapper.appendChild(wrapper);
        gallery.appendChild(mainwrapper);

        return gallery;
    }
};

export const initFullWidthGallerySlider = (slider) =>{
    const slides = slider.querySelectorAll(".swiper-slide");

    if (slides.length > 1) {

        const pagination = document.createElement("div");
        const control = document.createElement("div");

        pagination.classList.add(['swiper-pagination']);
        control.classList.add(['swiper-control'],['pause'],['icon-play-circle'],['pauseplayicon']);

        // append to the parent if in the editor
        if (slider.closest('.editor-slider-container')) {
            slider.parentNode.appendChild(pagination);
            slider.parentNode.appendChild(control);
        } else {
            slider.appendChild(pagination);
            slider.appendChild(control);
        }

        const swiper = new Swiper(slider, {
            modules: [Autoplay, Pagination],
            spaceBetween: 0,
            centeredSlides: true,
            speed: 1000,
            autoplay: {
                delay: 2000,
            },
            loop: true,
            slidesPerView:'auto',
            pagination: {
                el: pagination,
                clickable: true
            },
        });

        const swiperButton = slider.querySelector('.swiper-control');

        if(swiperButton){

            swiperButton.addEventListener('click', function(){

                if(this.classList.contains('pause')){
                    swiper.autoplay.stop();
                    this.classList.remove('pause')
                    this.classList.add('play')
                } else {
                    swiper.autoplay.start();
                    this.classList.remove('play')
                    this.classList.add('pause')
                }
            })
        }

        return swiper;
    }
};

export const initContainedGallerySlider = (slider) =>{
    const slides = slider.querySelectorAll(".swiper-slide");

    if (slides.length > 1) {

        const navigation = document.createElement("div");
        const buttonPrev = document.createElement("div");
        const buttonNext = document.createElement("div");


        navigation.classList.add(['navigation']);
        buttonPrev.classList.add(['swiper-prev']);
        buttonNext.classList.add(['swiper-next']);
        navigation.appendChild(buttonPrev);
        navigation.appendChild(buttonNext);

        // append to the parent if in the editor

        slider.parentNode.appendChild(navigation);

        const swiper = new Swiper(slider, {
            modules: [Autoplay, Navigation],
            spaceBetween: 0,
            centeredSlides: true,
            speed: 1000,
            // autoplay: {
            //     delay: 2000,
            // },
            loop: true,
            slidesPerView:1,
            navigation: {
                nextEl: buttonNext,
                prevEl: buttonPrev,
            },
        });

        return swiper;
    }
};

export function setFullWidthGallerySlider(){

    document.querySelectorAll('.is-style-full-width-slider').forEach(gallery => {
        const wrapper = prepareGallery(gallery);
        const slider = wrapper.querySelector('.swiper');
        initFullWidthGallerySlider(slider);
    });
}

export function setContainedGallerySlider(){

    document.querySelectorAll('.is-style-contained-slider').forEach(gallery => {
        const wrapper = prepareGallery(gallery);
        const slider = wrapper.querySelector('.swiper');
        initContainedGallerySlider(slider);
    });
}
